import React from 'react';
import { connect } from 'react-redux';

import ListPagePaginated from '@/src/shared/components/ListPage/ListPagePaginated';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';

const CatastropheClaimsGuide = () => {
  const [loading, results] = useListSearch({
    pubCode: 905,
    yearsBack: 5,
  });

  return (
    <ListPagePaginated
      title="Catastrophe Claims Guide"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      loading={loading}
    />
  );
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(
    CatastropheClaimsGuide,
    COMPLIANCE_ACCESS.CLAIMS_COMPLIANCE
  )
);
